import { useQuery } from '@tanstack/react-query'
import { axios } from 'lib/axios'
import { endpoints } from 'utils/endpoints'
import { ApiKey } from '../components/enums'

type GetTransactionParams = {
  threatId?: number
}

export function getChainTransaction(params: GetTransactionParams) {
  return axios.get(endpoints.getThreatChainTransaction, { params })
}

type UseTransactionParams = GetTransactionParams

export const useChainTransaction = (params: UseTransactionParams) => {
  return useQuery([ApiKey.incidentsHash, params], () => getChainTransaction(params))
}
